<template>
  <div class="w-100 bg-gray20 SECTION">
    <div class="container d-flex fd-column VALUE-LIST">
      <div class="h3 text-bold p-b-3">
        <div>{{content.title}}</div>
      </div>
      <div class="d-flex w-100 fd-column:mo VALUE-PROPS" >
        <div
            v-for="(record, index) in content.items"
            :key="index"
        ><value-props-item
            :item= record />
        </div>
      </div>
      <span class="text-sm"> {{content.footnote}}</span>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import ValuePropsItem from './components/ValuePropsItem';

export default {
  name: 'value-props',
  components: {
    ValuePropsItem,
  },

  computed: {
    ...mapGetters('homepage/contentful', [
      'customerHomePage',
    ]),
    content () {
      return this.customerHomePage.valueProps;
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@homeservices/design-kit/tools";
  .SECTION {
    margin-bottom: 10 * $unit;
  }
  .VALUE-LIST {
    @include padding(8);
    margin-bottom: $unit * 4;
  }
  .VALUE-PROPS {
    display: flex;
    flex: 1 1 auto;
    justify-content: space-between;
  }
</style>
